import React from 'react';
import PropTypes from 'prop-types';
import ConfigAssistantFlatListView from './ConfigAssistantFlatListView';
import ConfigAssistantNestedListView from './ConfigAssistantNestedListView';
import { uniqBy, filter } from 'lodash';
import BodyIcon from '../../common/icons/BodyIcon';

const ConfigsAndEnginesListView = props => {
  const {
    selectedDriveOption,
    selectedOption,
    options,
    flattened,
    onChange
  } = props;
  const { driveType, rearWheelType } = selectedDriveOption;

  const optionsFilteredByDrive = filter(options, { driveType, rearWheelType });

  const data = uniqBy(optionsFilteredByDrive, 'bodyTypeId')
    .map(x => {
      const {
        bodyTypeId,
        bodyTypeDescription,
        cabSize,
        driveType,
        rearWheelType
      } = x;
      return {
        id: bodyTypeId,
        cabSize,
        header: [bodyTypeDescription, driveType, rearWheelType]
          .filter(x => x)
          .join(', '),
        options: filter(optionsFilteredByDrive, { bodyTypeId })
      };
    })
    .filter(x => x.options.length > 0);

  if (flattened) {
    return (
      <ConfigAssistantFlatListView
        data={data}
        selectedOption={selectedOption}
        onChange={onChange}
      />
    );
  }

  return (
    <ConfigAssistantNestedListView
      data={data}
      selectedOption={selectedOption}
      renderLabel={option => option.engineDescription}
      renderGroupIcon={group => (
        <BodyIcon
          cabSize={group.cabSize}
          className="config-assistant-body-type__icon"
        />
      )}
      onChange={onChange}
    />
  );
};

ConfigsAndEnginesListView.propTypes = {
  selectedDriveOption: PropTypes.object.isRequired,
  selectedOption: PropTypes.object,
  options: PropTypes.array.isRequired,
  flattened: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default ConfigsAndEnginesListView;
